// Copyright © 2021 Move Closer
export var PopoverPositions;
(function (PopoverPositions) {
    PopoverPositions["Auto"] = "auto";
    PopoverPositions["AutoStart"] = "auto-start";
    PopoverPositions["AutoEnd"] = "auto-end";
    PopoverPositions["Top"] = "top";
    PopoverPositions["TopStart"] = "top-start";
    PopoverPositions["TopEnd"] = "top-end";
    PopoverPositions["Right"] = "right";
    PopoverPositions["RightStart"] = "right-start";
    PopoverPositions["RightEnd"] = "right-end";
    PopoverPositions["Bottom"] = "bottom";
    PopoverPositions["BottomStart"] = "bottom-start";
    PopoverPositions["BottomEnd"] = "bottom-end";
    PopoverPositions["Left"] = "left";
    PopoverPositions["LeftStart"] = "left-start";
    PopoverPositions["LeftEnd"] = "left-end";
})(PopoverPositions || (PopoverPositions = {}));
export var Triggers;
(function (Triggers) {
    Triggers["Hover"] = "hover";
    Triggers["Click"] = "click";
    Triggers["Focus"] = "focus";
    Triggers["Manual"] = "manual";
})(Triggers || (Triggers = {}));
